import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// mock
import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';
import brandlogo from '../../../components/logo/Tavant_Logo.png'

// ----------------------------------------------------------------------

const NAV_WIDTH = 180;

// const StyledAccount = styled('div')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   padding: theme.spacing(2, 2.5),
//   borderRadius: Number(theme.shape.borderRadius) * 1.5,
//   backgroundColor: alpha(theme.palette.grey[500], 0.12),
// }));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, pt: 2, display: 'inline-flex' }}>
        {/* <Logo /> */}
        <img src={brandlogo} alt='tavantlogo' style={{ width: "60%" }} />
      </Box>
      <br />


      <NavSection data={navConfig} />
      <Box>
        Some button
      </Box>
      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>

      </Box>
    </Scrollbar>
  );

  return (
    <Drawer
      sx={{
        flexShrink: 0
      }}
        open={openNav}
        onClose={onCloseNav}
        variant='persistent'
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          sx: { width: NAV_WIDTH },
        }}
      >
        {renderContent}
      </Drawer>
    // <Box
    //   component="nav"
    //   sx={{
    //     // flexShrink: { lg: 0 },
    //     // width: { lg: NAV_WIDTH },
    //   }}
    // >
      
    //   {isDesktop ? (
    //     <Drawer
    //       open
    //       variant="permanent"
    //       PaperProps={{
    //         sx: {
    //           width: NAV_WIDTH,
    //           bgcolor: 'background.default',
    //           borderRightStyle: 'dashed',
    //         },
    //       }}
    //     >
    //       {renderContent}
    //     </Drawer>
    //   ) : (
    //     <Drawer
    //       open={openNav}
    //       onClose={onCloseNav}
    //       ModalProps={{
    //         keepMounted: true,
    //       }}
    //       PaperProps={{
    //         sx: { width: NAV_WIDTH },
    //       }}
    //     >
    //       {renderContent}
    //     </Drawer>
    //   )}
    // </Box>
  );
}

